module.exports = __webpack_public_path__ + "static/media/bg.085c1def.png";